import React from 'react'
import PropTypes from 'prop-types'

import SwiperCore, { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { getImage } from 'gatsby-plugin-image'

import LinkedProduct from '../LinkedProduct/LinkedProduct'

SwiperCore.use([Pagination])

const LinkedProductSlider = ({ id, nodes }) => {
  return (
    <>
      <Swiper
        autoHeight
        spaceBetween={30}
        pagination={{
          el: `.swiper-pagination.swiper-pagination-${id}`,
          type: 'bullets',
          clickable: true,
        }}
        watchOverflow
        breakpoints={{
          1100: {
            slidesPerView: 3,
          },
        }}
      >
        {nodes.map(node => {
          const { id, data, fields } = node
          const { title, main_gallery: mainGallery, presellDate } = data
          const { pagePath } = fields
          const isPreorder = !!presellDate && new Date(presellDate) > new Date()
          let heroImage = null
          if (mainGallery.length) {
            const firstInGallery = mainGallery[0]
            if (firstInGallery.image && firstInGallery.image.localFile) {
              heroImage = getImage(firstInGallery.image.localFile)
            }
          }
          return (
            <SwiperSlide key={id}>
              <LinkedProduct
                heroImage={heroImage}
                isPreorder={isPreorder}
                pagePath={pagePath}
                title={title.text}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
      <div
        className={`-mt-6 sm:mt-0 swiper-pagination swiper-pagination-${id}`}
      ></div>
    </>
  )
}

LinkedProductSlider.propTypes = {
  id: PropTypes.string,
  nodes: PropTypes.array.isRequired,
}

LinkedProductSlider.defaultProps = {
  id: '',
}

export default LinkedProductSlider
